<template>
  <section>
    <div class="columns is-multiline">
      <div class="column is-8">
        <div class="box">
          <h1 class="has-text-weight-semibold is-size-4">Notifications</h1>
          <h1 class="has-text-weight-semibold is-size-6">Email notifications</h1>
          <div class="p-3">
            <div class="field">
              <b-checkbox>Account activity</b-checkbox>
            </div>
            <div class="field">
              <b-checkbox>News, special offers, contests and promotions </b-checkbox>
            </div>
          </div>
          <p class="has-text-justified pb-2 is-italic has-text-dark-orange">
            NOTE: Not implemented yet
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {}
</script>
